import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    codeNum:'',
    timestamp:'',
    LibraryInfo:{}
  },
  getters:{
    getCodeNum(state){
      return state.codeNum
    },
    getTimestamp(state){
      return state.timestamp
    },
    getLibraryInfo(state){
      return state.LibraryInfo
    },
  },
  mutations: {
    setCodeNum(state, data) {
      if (data) state.codeNum = data
    },
    setTimestamp(state, data) {
      if (data) state.timestamp = data
    },
    setLibraryInfo(state, data) {
      if (data) state.LibraryInfo = data
    },
  },
  actions: {
  },
  modules: {
  }
})
